// src/components/ExamSubmitScreen.jsx
// Final page shown after the last question - an overview of what's been
// answered, and the Submit button that collates everything into a PDF.

import React from 'react';
import { Send, CheckCircle, Circle, Flag, ArrowLeft } from 'lucide-react';

function plainTextWordCount(html) {
  const text = (html || '').replace(/<[^>]*>/g, ' ').trim();
  return text ? text.split(/\s+/).length : 0;
}

const ExamSubmitScreen = ({ homeworkName, groups, answers, submitting, submitStage, error, onGoToSection, onSubmit, onBack }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <div style={{ background: '#1a2332', color: 'white', padding: '16px 24px' }}>
        <div style={{ fontSize: '11px', letterSpacing: '1px', color: '#8b96a8', fontWeight: '700' }}>
          EXAM SIMULATION
        </div>
        <div style={{ fontSize: '17px', fontWeight: '700' }}>{homeworkName} - Review &amp; Submit</div>
      </div>

      <div style={{ flex: 1, padding: '40px', maxWidth: '600px', margin: '0 auto', width: '100%' }}>
        <h2 style={{ color: '#2c3e50' }}>Question Summary</h2>
        <div style={{ display: 'grid', gap: '8px', marginBottom: '24px' }}>
          {groups.map(group => {
            const answer = answers[group.id];
            const hasContent = plainTextWordCount(answer?.wordProcessor?.html) > 0;
            return (
              <button
                key={group.id}
                type="button"
                onClick={() => onGoToSection(group.id)}
                disabled={submitting}
                style={{
                  display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
                  padding: '12px 16px', background: 'white',
                  border: '2px solid #e2e8f0', borderRadius: '8px',
                  cursor: submitting ? 'not-allowed' : 'pointer', textAlign: 'left'
                }}
              >
                {hasContent ? <CheckCircle size={16} color="#1b998b" /> : <Circle size={16} color="#cbd5e0" />}
                <span style={{ flex: 1, fontWeight: '600', color: '#2c3e50' }}>{group.name}</span>
                {!hasContent && <span style={{ fontSize: '12px', color: '#e74c3c' }}>Not answered</span>}
                {answer?.flagged && <Flag size={14} color="#e74c3c" fill="#e74c3c" />}
              </button>
            );
          })}
        </div>

        {error && (
          <div style={{ padding: '12px', marginBottom: '16px', background: '#fee2e2', border: '1px solid #fecaca', borderRadius: '8px', color: '#991b1b', fontSize: '14px' }}>
            {error}
          </div>
        )}

        <div style={{ fontSize: '13px', color: '#718096', marginBottom: '20px' }}>
          Once you submit, you won't be able to make further changes. Check your answers above before continuing.
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          {onBack && (
            <button
              type="button"
              onClick={onBack}
              disabled={submitting}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center',
                padding: '16px 20px', background: 'white',
                color: '#2c3e50', border: '2px solid #e2e8f0', borderRadius: '8px',
                cursor: submitting ? 'not-allowed' : 'pointer', fontWeight: '700', fontSize: '16px'
              }}
            >
              <ArrowLeft size={18} />
              Back to Task
            </button>
          )}
          <button
            type="button"
            onClick={onSubmit}
            disabled={submitting}
            style={{
              display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center',
              flex: 1, padding: '16px', background: submitting ? '#cbd5e0' : '#c33329',
              color: 'white', border: 'none', borderRadius: '8px',
              cursor: submitting ? 'not-allowed' : 'pointer', fontWeight: '700', fontSize: '16px'
            }}
          >
            <Send size={18} />
            {submitting ? 'Submitting...' : 'Submit Task'}
          </button>
        </div>

        {submitting && (
          <div style={{ marginTop: '12px', textAlign: 'center', fontSize: '13px', color: '#718096' }}>
            {submitStage || 'Submitting...'} This can take up to a minute - please don't close this window.
          </div>
        )}
      </div>
    </div>
  );
};

export default ExamSubmitScreen;
